/**
 * The answer while it streams: a provisional bubble that grows with each `delta` (display text
 * only, set through textContent) and is replaced by the stored message when `final` arrives.
 */

export const LIVE_TEXT = {
  streaming: 'El Asistente Guru está respondiendo…',
} as const;

/** What the last streamed answer showed before its final message (read by the e2e through the debug hook). */
export interface StreamTrace {
  deltas: number;
  text: string;
}

let lastTrace: StreamTrace = { deltas: 0, text: '' };

export function lastStream(): StreamTrace {
  return { ...lastTrace };
}

export class LiveAnswer {
  private node: HTMLElement | null = null;
  private textNode: HTMLElement | null = null;
  private text = '';
  private deltas = 0;

  constructor(private readonly log: HTMLElement, private readonly before: HTMLElement | null) {
    lastTrace = { deltas: 0, text: '' };
  }

  /** True until the first delta is shown. */
  get empty(): boolean {
    return this.deltas === 0;
  }

  add(delta: string): void {
    if (!delta) return;
    this.text += delta;
    this.deltas += 1;
    lastTrace = { deltas: this.deltas, text: this.text };
    if (!this.node) this.build();
    if (this.textNode) this.textNode.textContent = this.text;
    this.node?.scrollIntoView?.({ block: 'nearest' });
  }

  private build(): void {
    const node = document.createElement('div');
    node.className = 'assistant-msg assistant-msg-assistant assistant-live';
    node.dataset.role = 'assistant';
    node.setAttribute('aria-busy', 'true');
    const text = document.createElement('div');
    text.className = 'assistant-msg-text';
    const note = document.createElement('div');
    note.className = 'assistant-trace';
    note.textContent = LIVE_TEXT.streaming;
    node.append(text, note);
    // Before the "pensando…" line, so the status stays last while text arrives.
    if (this.before?.parentNode === this.log) this.log.insertBefore(node, this.before);
    else this.log.appendChild(node);
    this.node = node;
    this.textNode = text;
  }

  remove(): void {
    this.node?.remove();
    this.node = null;
    this.textNode = null;
  }
}
